import React from 'react';
import { Image } from 'react-bootstrap'
import './index.css'
import icon1 from '../../assets/images/icon1.svg'
import icon2 from '../../assets/images/icon2.svg'
import icon3 from '../../assets/images/icon3.svg'
import ReviewActive from '../../assets/images/ReviewActive.svg'
import ReviewInactive from '../../assets/images/ReviewInactive.svg'

const BadgeIcon = ({ isValid, isFreeReview, orderService }) => {
  return (
    <div className='badge-icon-container'>     
      { isFreeReview ? <Image
        style={{ width: '46px', height: '46px' }}
        src={ orderService===2 ? icon1 : orderService===1 ? icon2 : icon3 }
        alt='badge'
      /> : 
        <Image
        style={{ width: '46px', height: '46px' }}
        src={ isValid ? ReviewActive : ReviewInactive }
        alt='badge'
      /> 
    }
    </div>
  )
}

export default BadgeIcon
